<ng-template #videoModal let-modal>
    <div class="modal-content">
        <div class="modal-body">
            <iframe src="https://www.youtube.com/embed/FRIDLxM8Roc" allowfullscreen></iframe>
        </div>
    </div>
</ng-template>
